// From https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
export function bytesToHumanReadableSize(size: number) {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1000));
  // @ts-ignore
  return `${(size / 1000 ** i).toFixed(2) * 1} ${
    ["B", "KB", "MB", "GB", "TB"][i]
  }`;
}
